import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

import regionRoutes from './RCompetitionRegion'
import videoRegionRoutes from './RVideoCompetitionRegion'
import managementRouters from './RCompetitionManagement'
import onlineGameRouters from './RCompetitionOnlineGames'
import sportsFestivalRouters from './RSportsFestival2022'

import competitionMenuIcon from '@/assets/images/icon_menu_competition@2x.png'
import competitionMenuIconActive from '@/assets/images/icon_menu_competition_active@2x.png'

const Layout = () => import('../views/Layout.vue')

const List = () => import('@/views/CompetitionList.vue')
const Edit = () => import('../views/CompetitionCreate.vue')
const Launch = () => import('../views/CompetitionLaunch.vue')
const Landing = () => import('../views/digital-sports-meeting/Landing.vue')
const OnlineLaunch = () => import('../views/CompetitionOnlineLaunch.vue')
const Detail = () => import('@/views//CompetitionDetail.vue')
const DetailInfo = () => import('@/views//CompetitionDetailInfo.vue')
const DetailStat = () => import('@/views//CompetitionDetailStat.vue')
const OnlineIntro = () => import('@/views/CompetitionOnlineNotPayIntro.vue')

const CompetitionIntroPage = () => import('@/views/CompetitionNotVipIntro.vue')

const CreateSportsMeeting = () => import('../views/sports-meeting/Create.vue')

export const onlineIntroRoute: RouteConfig = {
  path: 'online-intro',
  name: 'online_intro',
  component: OnlineIntro,
  meta: {
    title: '运动会介绍',
    // showMenu: true,
  },
}

export const listRoute: RouteConfig = {
  path: 'index',
  name: 'competition_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '校内云比赛',
    showMenu: true,
  },
}

export const editRoute: RouteConfig = {
  path: 'edit',
  name: 'competition_edit',
  component: Edit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '校内云比赛',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const launchRoute: RouteConfig = {
  path: 'launch',
  name: 'competition_launch',
  component: Launch,
  meta: {
    title: '发起比赛',
    showMenu: true,
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const landingRoute: RouteConfig = {
  path: 'landing',
  name: 'digital_sports_meeting_landing',
  component: Landing,
  meta: {
    title: '数字运动会',
    showMenu: true,
  },
}

export const onlineLaunchRoute: RouteConfig = {
  path: 'online-launch',
  name: 'competition_online_launch',
  component: OnlineLaunch,
  meta: {
    title: '在线运动会',
    // showMenu: true,
  },
}

export const detailRoute: RouteConfig = {
  path: 'detail',
  name: 'competition_detail',
  component: Detail,
  children: [
    {
      path: 'stat',
      name: 'competition_detail_stat',
      component: DetailStat,
      props: (route) => ({ id: route.query.id }),
      meta: { title: '校内云比赛' },
    },
    {
      path: 'info',
      name: 'competition_detail_info',
      component: DetailInfo,
      props: (route) => ({ id: route.query.id }),
      meta: { title: '校内云比赛' },
    },
  ],
}

export const competitionIntroRoute: RouteConfig = {
  path: 'competition-intro',
  name: 'competition_intro',
  component: CompetitionIntroPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '办赛服务',
    showMenu: false,
  },
}

export const createSportsMeetingRoute: RouteConfig = {
  path: '/sports-meeting-2022/create',
  name: 'sports_meeting_2022_create',
  component: CreateSportsMeeting,
  props: (route) => {
    return { ...route.query }
  },
  meta: {
    title: '在线运动会',
    showMenu: false,
  },
}

export default [
  {
    path: '/competition',
    name: 'competition',
    component: Layout,
    meta: {
      title: '体育比赛',
      icon: competitionMenuIcon,
      iconActive: competitionMenuIconActive,
      // isVip: true,
      showMenu: true,
    },
    children: [
      landingRoute,
      detailRoute,
      editRoute,
      launchRoute,
      ...managementRouters,
      ...onlineGameRouters,

      ...regionRoutes,
      onlineLaunchRoute,

      ...videoRegionRoutes,
      competitionIntroRoute,

      listRoute,
      onlineIntroRoute,

      ...sportsFestivalRouters,

      createSportsMeetingRoute,
    ],
  },
]

export function navigateToWebCreateCompetition(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function navigateToCompetitionDetailStat(router: VueRouter, id: number) {
  router.push({ name: 'competition_detail_stat', query: { id: `${id}` } })
}
